module.exports = __webpack_public_path__ + "img/js.2d3bf158.png";